/**
 * TitleScreen - Beautiful animated title screen
 */

import { useEffect, useState } from 'react';
import PipCharacter from '../characters/PipCharacter';
import './TitleScreen.css';

export default function TitleScreen({ 
  onStartNew, 
  onContinue, 
  onSettings, 
  hasSavedProgress,
  savedLevel 
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Trigger entrance animations
    requestAnimationFrame(() => setMounted(true));
  }, []);

  return (
    <div className={`title-screen ${mounted ? 'mounted' : ''}`}>
      {/* Animated background */}
      <div className="title-bg">
        <div className="title-bg__gradient" />
        <div className="title-bg__stars">
          {[...Array(20)].map((_, i) => (
            <div 
              key={i} 
              className="floating-star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
            >
              {['⭐', '✨', '🌟', '💫'][Math.floor(Math.random() * 4)]}
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="title-content">
        {/* Logo */}
        <div className="title-logo">
          <h1 className="title-logo__main">Pip's</h1>
          <h2 className="title-logo__sub">Kitchen Adventure</h2>
        </div>

        {/* Pip Character */}
        <div className="title-pip">
          <PipCharacter 
            mood="excited" 
            animation="bounce"
            size="large"
          />
        </div>

        {/* Tagline */}
        <p className="title-tagline">
          Help Pip find yummy snacks using your voice!
        </p>

        {/* Buttons */}
        <div className="title-buttons">
          {hasSavedProgress && (
            <button className="btn btn--continue" onClick={onContinue}>
              Continue
              <span className="btn__level">Level {savedLevel + 1}</span>
            </button>
          )}
          
          <button className="btn btn--play" onClick={onStartNew}>
            <span className="btn__icon">▶</span>
            {hasSavedProgress ? 'New Game' : 'PLAY'}
          </button>
          
          <button className="btn btn--settings" onClick={onSettings}>
            <span className="btn__icon">⚙️</span>
            Settings
          </button>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="title-decor">
        <div className="title-decor__item title-decor__item--apple">🍎</div>
        <div className="title-decor__item title-decor__item--juice">🧃</div>
        <div className="title-decor__item title-decor__item--cookie">🍪</div>
        <div className="title-decor__item title-decor__item--banana">🍌</div>
      </div>
    </div>
  );
}
